(function() {
    'use strict';

    angular
        .module('app.pilotos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/pilotos',
                config: {
                    templateUrl: 'app/pilotos/list.html',
                    controller: 'pilotos.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-piloto/:id?',
                config: {
                    templateUrl: 'app/pilotos/edit.html',
                    controller: 'pilotos.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
